<template>
  <Icon :name="name" :class="['inline-block', iconSize]" aria-hidden="true" />
</template>

<script setup lang="ts">
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  size: {
    type: String as PropType<"xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "xxxl">,
    default: "sm",
  },
});

const iconSize = computed(() => {
  const sizeClassMap = {
    xs: "h-4 w-4",
    sm: "h-5 w-5",
    md: "h-6 w-6",
    lg: "h-8 w-8",
    xl: "h-10 w-10",
    xxl: "h-12 w-12",
    xxxl: "w-24 h-24",
  };
  return sizeClassMap[props.size] ?? "h-5 w-5";
});
</script>
